<coop-good-price-form
  [editMode]="false"
  [templateMode]="true"
  [formData]="formData"
></coop-good-price-form>
